<script setup>
import { computed, onMounted } from 'vue'
import {
  NLoadingBarProvider
} from 'naive-ui'
import { useStore } from 'vuex'

import ConnnectionNotification from '@/components/notification.vue'
import TimeoutPopUp from '@/components/timeOutPopUp.vue'
import AppProvider from '@/components/application/appProvider.vue'

const { dispatch, getters } = useStore()

const user = computed(() => getters['users/_user'])

const isUserInactive = computed(() => getters['sessionInactivity/_isUserInactive'])

onMounted(async () => {
  // starts event timer
  if (user.value) {
    const headers = {
      Authorization: `${getters['users/_tokenType']} ${getters['users/_apiRequestToken']}`
    }

    dispatch('sessionInactivity/StartSessionTimer', { headers })
  }
})
</script>

<template>
  <!--app content ------- -->
  <NLoadingBarProvider>
    <AppProvider>
      <!-- --------- -->
      <div>
        <!-- connection notifiction -->
        <ConnnectionNotification />
        <!-- session Timeout popup -->
        <TimeoutPopUp v-if="isUserInactive" />
        <!-- page view -->
        <RouterView v-else />
      </div>
      <!-- --------- -->
    </AppProvider>
  </NLoadingBarProvider>
</template>

<style lang="scss">
  // Gelion fonts
  @font-face {
    font-family: 'Gelion-Regular';
    src: url('./assets/fonts/Gelion-Regular.ttf');
    font-style: normal;
  }
  @font-face {
    font-family: 'Gelion-Bold-Black';
    src: url('./assets/fonts/Gelion-Black.ttf');
    font-style: normal;
  }
  @font-face {
    font-family: 'Gelion-Medium';
    src: url('./assets/fonts/Gelion-Regular.ttf');
    font-style: normal;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  #app {
    scroll-behavior: smooth;
    font-size: initial;
  }

  // MEDIA QUERY

  // XX-SM (<230px)
  @media (max-width: 230.9px) {
    // show nothing on very small devices
    #app {
      display: none;
    }
  }

// PRINT
/* print.css */
@page {
  size: landscape;
}
</style>
